import { Inject, Injectable, Optional } from '@angular/core';
import { BaseService } from './base.service';

const CONFIG_STORE_KEY = 'config';

export const CONFIG_DATA = 'mtg-core-config-data';

@Injectable({providedIn: 'root'})
export class ConfigService extends BaseService {
  constructor(
    @Optional() @Inject(CONFIG_DATA) private configData: any
  ) {
    super();
    if (configData) {
      this.initialize(configData);
    }
  }

  get config$() {
    return this.store.get(CONFIG_STORE_KEY);
  }

  get config() {
    return this.store.value(CONFIG_STORE_KEY) || {};
  }

  initialize(data: any): void {
    this.store.save(CONFIG_STORE_KEY, data);
  }

  set(key: string, value: any): void {
    this.store.save(CONFIG_STORE_KEY, {
      ...this.config,
      [key]: value
    });
  }

  get(key: string): any {
    return this.store.value(CONFIG_STORE_KEY) && this.store.value(CONFIG_STORE_KEY)[key];
  }
}
